import React, { useState } from 'react'
import {
  Box,
  Button,
  Checkbox,
  Flex,
  Heading,
  Message,
  Modal,
  Text,
} from '@workwhile/ui'
import { useEditRequirementFlowContextValue } from '../context/EditRequirementFlowProvider'
import { usePositionDetailWorkflowsContextValue } from '../../../context/PositionDetailWorkflowProvider'

const RequirementDataRow = ({
  label,
  value,
}: {
  label: string
  value: string
}) => (
  <Box>
    <Text fontWeight="bold">{label}</Text>
    <Text>{value}</Text>
  </Box>
)

export const EditRequirementFlowMain = () => {
  const {
    editRequirementFlow: { isOpen, close },
  } = usePositionDetailWorkflowsContextValue()

  const {
    state: { requirement, isPending, errorMessage },
    actions: { submit, reset },
  } = useEditRequirementFlowContextValue()

  const [mustHave, setMustHave] = useState(requirement.mustHave)

  const handleClose = () => {
    setMustHave(requirement.mustHave)
    reset()
    close()
  }

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      position="top"
      loading={isPending}
      customCta={
        <Flex>
          <Button variant="text" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            loading={isPending}
            onClick={() => submit(mustHave)}
          >
            Save
          </Button>
        </Flex>
      }
    >
      <Heading level={2} m={0}>
        Edit requirement on position
      </Heading>

      <Flex mt={3} flexDirection="column" gap={3}>
        <RequirementDataRow
          label="Requirement Name (Id)"
          value={`${requirement.name} (${requirement.id})`}
        />
        <RequirementDataRow
          label="Verification Type"
          value={requirement.verificationType}
        />
        <RequirementDataRow label="Category" value={requirement.category} />
      </Flex>

      <Box mt={3} pt={3} borderTop="1px solid" borderColor="neutrals.100">
        <Text fontSize={2} fontWeight="medium" mb={2}>
          Configurable fields
        </Text>
        <Checkbox value={mustHave} onChange={setMustHave}>
          <Box>
            <Text fontWeight="medium">Must Have</Text>
            <Text color="lightText" fontSize={1}>
              Workers cannot accept a shift without meeting this requirement
            </Text>
          </Box>
        </Checkbox>
      </Box>

      {errorMessage ? (
        <Message variant="error" mt={3} borderRadius="small">
          {errorMessage}
        </Message>
      ) : null}
    </Modal>
  )
}
